import { useEffect, useState } from 'react';

/**
 * @typedef {'unsupported' | 'noSW' | 'default' | 'denied' | 'granted'} NotificationState
 */

function resolveInitialState() {
  if (typeof window === 'undefined') return 'unsupported';
  if (!('Notification' in window)) return 'unsupported';
  if (!('serviceWorker' in navigator)) return 'noSW';
  return Notification.permission;
}

/**
 * Track notification / service worker support in real time.
 * @returns {NotificationState}
 */
export function useNotificationStatus() {
  const [state, setState] = useState(() => resolveInitialState());

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!('Notification' in window)) return;
    if (!('serviceWorker' in navigator)) return;

    setState(Notification.permission);

    // @ts-expect-error Permission API typing differs across browsers
    navigator.permissions?.query?.({ name: 'notifications' })
      .then((status) => {
        status.onchange = () => setState(Notification.permission);
      })
      .catch(() => {
        // Permission API not supported; rely on reloads
      });
  }, []);

  return /** @type {NotificationState} */ (state);
}

